/**
 * LoanAndNoteBar
 * 
 * @Author: Focci
 * @Date: 2023-08-07 21:02:54
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 21:02:54
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import clsx from 'clsx'
import { Waypoint } from 'react-waypoint'
import { useCallback } from 'react'
import { Skeleton } from '@comp/material'
// import LoanBar from './LoanBar'
// import NoteBar from './NoteBar'

function LoanAndNoteBarSkeleton() {
  return (
    <div className="flex items-center justify-between">
      <div className="flex-auto">
        <Skeleton style={{ width: '50%', height: '1.5rem' }} />
        <Skeleton style={{ width: '70%' }} />
      </div>
      <div className="h-[2.1rem] bg-cf0 w-24 rounded-sm" />
    </div>
  )
}

export default function LoanAndNoteBar({
  showNote = true,
  showLoan = true,
  house = {}
}) {
  const { Wedget: LoanBar, getWedget: getLoanBar, ready: loanReady } = useLazyComponent()
  const { Wedget: NoteBar, getWedget: getNoteBar, ready: noteReady } = useLazyComponent()

  const handleEnter = useCallback(() => {
    showLoan && getLoanBar(() => import('./LoanBar'))
    showNote && getNoteBar(() => import('./NoteBar'))
  }, [getLoanBar, getNoteBar, showLoan, showNote])

  if(!(showLoan || showNote)) {
    return null
  }
  
  return (
    <Waypoint onEnter={handleEnter}>
      <div 
        className={clsx([
          'mt-4 grid grid-cols-1 xl:grid-cols-2 gap-x-8 gap-y-4',
          house.description ? 'border-y py-4' : 'border-t pt-4'
        ])}
      >
        {showLoan && (loanReady ? <LoanBar house={house} /> : <LoanAndNoteBarSkeleton />)}
        {showNote && (noteReady ? <NoteBar house={house} /> : <LoanAndNoteBarSkeleton />)}
      </div>
    </Waypoint>
  )
}

LoanAndNoteBar.propTypes = {
  showNote: PropTypes.bool,
  house: PropTypes.object,
}
